module.exports = __webpack_public_path__ + "static/media/garble2.116d58fe.mp3";